import React, { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAnimation } from '../../contexts/AnimationContext';

// 组件属性类型定义
interface PageTransitionProps {
  children: ReactNode;
  location: string; // 当前路由路径，用于触发动画
}

// 页面过渡动画变体
const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: 'easeInOut',
    },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
    },
  },
};

// 页面过渡组件
const PageTransition: React.FC<PageTransitionProps> = ({ children, location }) => {
  // 使用动画上下文
  const { isPageChanging } = useAnimation();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location}
        initial="initial"
        animate="animate"
        exit="exit"
        variants={pageVariants}
        style={{ 
          opacity: isPageChanging ? 0.5 : 1, // 页面切换时降低透明度
          transition: 'opacity 0.3s',
        }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition; 